import { observable, action } from "mobx";
import { ApiUrl, ApiService } from "../helpers";

const featureStore = observable(
  {
    featureFlags: {}, // Store all flags here

    setFeatureFlag(code, value) {
      this.featureFlags[code] = value;
    },

    getFeatureFlag(code) {
      return this.featureFlags[code];
    },

    fetchFeatureFlag(code) {
      return ApiService.get(ApiUrl.getFeatureFlags + code)
        .then(
          action(response => {
            if (
              response &&
              response.status === 200 &&
              response.data &&
              !response.data.isError
            ) {
              this.setFeatureFlag(code, response.data.result);
              return response.data.result;
            }
            return response;
          })
        )
        .catch(
          action(err => {
            console.log(err);
          })
        );
    }
  },
  {
    setFeatureFlag: action,
    fetchFeatureFlag: action
  }
);

export default featureStore;